import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PresentationComponent } from './presentation/presentation.component';

const routes: Routes = [
  {path: '', component: PresentationComponent, pathMatch:'full'},
  {path: 'presentation', redirectTo: '', pathMatch: 'full'},
  {path: 'activity', loadChildren: () => import('./activity/activity.module').then(m => m.ActivityModule)},
  {path: 'contact', loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule)},
  {path: 'confidentiality', loadChildren: () => import('./page-confidentialite/page-confidentialite.module').then(m => m.PageConfidentialiteModule)},
  {path: '**', redirectTo: '', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, enableTracing: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
